import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Tag } from './atoms/Tag';
import type { TagSize } from './atoms/Tag';

interface SuspiciousActivityBadgeProps {
  className?: string;
  children?: React.ReactNode;
  /** Maps to Tag size. */
  size?: TagSize;
  withAlert?: boolean;
}

/**
 * Domain preset: danger Tag for interview cheating / suspicious activity flags.
 * Public API kept for existing call sites; implementation uses Tag (PR3).
 */
export const SuspiciousActivityBadge: React.FC<SuspiciousActivityBadgeProps> = ({
  className,
  children,
  size = 'md',
  withAlert = true,
}) => {
  const { t } = useTranslation('candidates');
  return (
    <Tag
      intent="error"
      variant="subtle"
      size={size}
      icon={withAlert ? <AlertTriangle /> : undefined}
      className={className}
    >
      {children || t('meta_cv.suspicious_activity_badge')}
    </Tag>
  );
};
